if (!customElements.get("product-recommendations")){
  class ProductRecommendations extends HTMLElement {
    observer = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeRecommendations(this.dataset.productId);
    }

    initializeRecommendations(productId) {
      this.observer?.unobserve(this);
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.loadRecommendations(productId);
        },
        { rootMargin: "0px 0px 400px 0px" }
      );
      this.observer.observe(this);
    }

    /** Recalculate Swiper widths after section HTML swap (avoids mobile layout “growing” past the viewport). */
    syncSwipersAfterInject() {
      const reveal = () => {
        this.classList.add('product-recommendations--ready');
        this.querySelectorAll('.swiper').forEach((el) => {
          el.classList.add('is-layout-ready');
        });
      };

      const bump = () => {
        requestAnimationFrame(() => {
          this.querySelectorAll('.swiper').forEach((el) => {
            el.swiper?.update?.();
            if (el.classList.contains('swiper-initialized')) {
              el.classList.add('is-layout-ready');
            }
          });
          const allReady = [...this.querySelectorAll('.swiper')].every(
            (el) => el.classList.contains('swiper-initialized') || !el.querySelector('.swiper-slide')
          );
          if (allReady) reveal();
        });
      };

      bump();
      queueMicrotask(bump);
      // Swiper custom element may init a frame or two later after HTML inject
      [50, 150, 350, 700].forEach((ms) => setTimeout(bump, ms));

      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', bump, { once: true });
      });

      // Fallback: never leave carousel invisible
      setTimeout(reveal, 1200);
    }

    loadRecommendations(productId) {
      fetch(
        `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
      )
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations?.innerHTML.trim().length) {
            this.classList.remove('product-recommendations--ready');
            this.innerHTML = recommendations.innerHTML;
            this.syncSwipersAfterInject();
          }

          if (this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
          this.classList.add('product-recommendations--ready');
        });
    }
  }
  
  customElements.define("product-recommendations", ProductRecommendations);
}